<template>
  <div class="navigation" :class="`step${step}`">
    <nav
      class="calcnav isActive"
      id="js--calcnav"
      v-if="notResult"
      :class="{ marked: step > 4 }"
    >
      <div class="grid-x">
        <div class="small-4 cell flex flex--centerY">
          <button
            class="swBtn swBlack calcnav__btn calcnav__btn--prev"
            :class="{ isActive: togglePrevious() }"
            :disabled="!togglePrevious()"
            title="Forrige steg"
            @click="navigatePrev"
          >
            <span class="icon arrowleft textalign"></span>
            &nbsp; <span class="show-for-medium">Forrige</span>
          </button>
        </div>
        <div class="small-4 cell flex flex--center">
          <p class="mb--0">Steg {{ step }} / {{ steps }}</p>
        </div>
        <div class="small-4 cell text-right">
          <button
            @click="navigateNext"
            class="swBtn swBlack calcnav__btn calcnav__btn--next"
            :class="{ isActive: canNext }"
            :disabled="!canNext"
            title="Neste steg"
          >
            <span class="show-for-medium">{{ nextBtnTxt() }} </span>
            &nbsp;
            <span class="icon arrowright textalign"></span>
          </button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  mounted() {
    let routes = this.$router.options.routes;
    const regex = /\/\d/g;
    const filtered = routes.filter((route) => route.path.match(regex));
    filtered.sort(function(a, b) {
      return parseInt(a.path.substring(1)) - parseInt(b.path.substring(1));
    });
    filtered.forEach((route) => {
      this.order.push(route.name);
    });
    var index = this.order.indexOf(this.$route.name);
    this.step = index + 1;
    this.$eventBus.$on("allowNext", (data) => {
      this.eventCanNext = data;
    });

    this.$eventBus.$on("nav", (data) => {
      if (data == "prev") {
        this.navigatePrev();
      } else {
        this.navigateNext();
      }
    });
  },
  data() {
    return {
      order: [],
      steps: 16,
      step: 1,
      eventCanNext: false,
    };
  },
  computed: {
    notResult() {
      return true;
    },
    sex: {
      get() {
        return this.$store.state.sex;
      },
    },
    canNext() {
      if (this.step > 4 && this.step < 17) {
        return this.eventCanNext;
      }
      return true;
    },
  },
  methods: {
    nextBtnTxt: function() {
      if (this.order.indexOf(this.$route.name) == this.order.length - 1) {
        return "Finish";
      }
      return "Neste";
    },

    togglePrevious() {
      if (this.$route.name == this.order[0]) {
        return false;
      }
      return true;
    },
    navigateNext() {
      var index = this.order.indexOf(this.$route.name);
      this.step = index + 2;

      if (index > -1 && index < this.order.length - 1) {
        this.$router.push("/" + (index + 2) + "/");
      }
    },
    navigatePrev() {
      var index = this.order.indexOf(this.$route.name);
      this.step = index;
      if (index > 0 && index < this.order.length) {
        this.$router.push("/" + index + "/");
      }
    },
  },
  watch: {
    $route(to, from) {
      setTimeout(function() {
        jQuery("html, body")
          .stop()
          .animate({ scrollTop: 0 }, 500, "swing");
      }, 200);
      var index = this.order.indexOf(to.name);
      this.step = index + 1;
    },
  },
};
// http://avogtil.test/habits-kalkulator/#/17/?m=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
</script>
<style lang="scss">
div.step17 {
  display: none;
}
@media screen and (max-width: 639px) {
  .calcnav {
    z-index: 101;
    top: 60px;
    bottom: auto;
  }
  .navigation {
    .calcnav {
      .calcnav__btn {
        &:not(.isActive) {
          transform: translate3d(100%, 0, 0);
        }
        &:hover,
        &:focus,
        &:active {
          background-color: #083650;
          border-color: #083650;
        }
        .icon {
          animation: none !important;
        }
      }
      &.marked {
        .calcnav__btn--next:not(.isActive) {
          opacity: 0.5;
          transform: none;
        }
        .calcnav__btn--next.isActive {
          opacity: 1;
          background-color: #ef5050;
          border-color: #ef5050;
          &:hover,
          &:focus,
          &:active {
            background-color: #ef5050;
            border-color: #ef5050;
          }
        }
      }
    }
  }
}
</style>
